<div class="boxcard flex h-full max-h-[450px]">
  @if ((getBoxCountrypersonsprice()?.boxdiscountpercentage || getBoxCountrypersonsprice()?.boxdiscountamount) && qtyeditable) {
  <div class="discountprice rounded-lg text-white px-1 bg-e-gold m-2 absolute">
    @if (getBoxCountrypersonsprice()?.boxdiscountpercentage) {
    <small class="text-dark">
      {{calculatedPrice?.calculateddiscountpercentage }}% {{'common.discount' | translate}}
    </small>
    }@else {
    <small class="text-dark">
      {{calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} {{'common.discount' | translate}}
    </small>
    }
  </div>
  }

  <div class="flex flex-col rounded-lg bg-white justify-between w-full p-[15px] md:p-6">
    <div class="flex justify-center items-center h-[170px] overflow-hidden">
      @if (!disableShowAction) {
      <app-image (click)="showBoxAction()" size="md" [imageobject]="_box" alt="{{_box?.title}}" class="flex flex-row justify-center object-cover cursor-pointer"></app-image>
      }@else {
      <a [routerLink]="[_box? _box['boxurl']: '']">
        <app-image [imageobject]="_box" size="md" alt="{{_box?.title}}" class="flex flex-row justify-center object-cover"></app-image>
      </a>
      }
    </div>

    <div class="">
      @if (!disableShowAction) {
      <h3 (click)="showBoxAction()" class="text-base md:text-xl font-sans cursor-pointer">
        <!-- makes sure that a translated version is shown if a box or product is set with the orderdescription as fallback -->
        {{_box? _box?.title || _box?.description: _orderline?.description}}
      </h3>
      }@else {

      <h3 [routerLink]="[_box? _box['boxurl']: '']" class="text-base md:text-xl font-sans">
        <!-- makes sure that a translated version is shown if a box or product is set with the orderdescription as fallback -->
        {{_box? _box?.title || _box?.description: _orderline?.description}}
      </h3>

      }
      <small class="">{{_box?.subtitle}}</small>
    </div>
    @if (qtyeditable || repeatableeditable) {
    <div class="flex flex-row">
      <pricetag class=" mt-2.5" [productprice]="true" [calculatedPrice]="calculatedPrice"></pricetag>
    </div>
    }
    @if (qtyeditable) {
    <div class="flex flex-row items-center mt-[15px]">
      <strong class="capitalize hidden md:block">{{'common.pieces' |translate }}</strong>
      <app-quantityselection class="md:ml-[15px] w-full" [quantity]="quantity.value" (quantityChange)="setQuantity($event)"
        [contrastColorscheme]="colorscheme"></app-quantityselection>
    </div>
    }
    @if (personseditable) {
    <div class="flex flex-row items-center mt-[15px]">
      <strong class="capitalize hidden md:mr-2.5 md:block">{{'common.person_abbr'|translate}}</strong>
      <app-personselection class="md:ml-[15px] w-full" [contrastColorscheme]="colorscheme" [persons]="persons.value" (personsChange)="setPersonQuantity($event)"
        [personsoptions]="_box?._boxpersons" [doublepersons]="_box?.doublepersons">
        <span class="md:hidden">{{'common.person_abbr'|translate}}</span>
      </app-personselection>
    </div>
    }
    @if(!qtyeditable){<span>{{'common.piece' |translate : {count: quantity.value} }}</span>}
    @if(!personseditable){<span>{{_box?.doublepersons? persons.value * 2 : persons.value}} {{'common.person_abbr'|translate}}</span>}
    @if(repeatableeditable){<app-toggle class="ms-2 mt-6" [formControl]="repeatable" color="success">{{'subscription.product_weekly' | translate}}</app-toggle>}
  </div>
</div>